module.exports = __webpack_public_path__ + "img/topo_base.488f10fe.png";